var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 230 301.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fac500;}.cls-2{fill:#343231;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_2",
    "data-name": "\\uB808\\uC774\\uC5B4 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB808\\uC774\\uC5B4_1-2",
    "data-name": "\\uB808\\uC774\\uC5B4 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.14,229.33H83.36a128.92,128.92,0,0,1-38.61,27.35s9.1,34,12,44.72c0,0,103.56-16.5,163-86.49l-13.86-8.41A126.63,126.63,0,0,1,133.14,229.33Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 230,
    height: 230,
    rx: 43.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.39,91.41a2.87,2.87,0,0,1-.17-.59C33,78.44,56.64,75.28,64.23,77.67a32.2,32.2,0,0,1,10.93,6c1.2,1,8.92,10.68,3.37,10.81a3.93,3.93,0,0,1-2.24-.92C71.22,90,68.52,84.67,62.13,83.14A20.51,20.51,0,0,0,42.52,89C41,90.72,37.07,95.49,35.39,91.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.36,91.41a2.88,2.88,0,0,0,.18-.59c2.2-12.38-21.42-15.54-29-13.15a32.15,32.15,0,0,0-10.92,6c-1.2,1-8.92,10.68-3.37,10.81a3.93,3.93,0,0,0,2.24-.92c5.07-3.59,7.77-8.89,14.16-10.42a20.49,20.49,0,0,1,19.6,5.9C185.78,90.72,189.69,95.49,191.36,91.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.71,134.59c28.42,9.78,61.45,9.18,89.8-.61a100.7,100.7,0,0,0,28.74-15.19c2.69-2.08,7.62-6.44,10.78-2.38,1.81,2.32.29,6.19-.95,8.42-3,5.4-8.35,9.22-13.22,12.82A97.49,97.49,0,0,1,163,149.17a125.49,125.49,0,0,1-39.37,8.72c-5.06.34-10.15.43-15.22.28l-.44,0a152.7,152.7,0,0,1-21.55-2.23,121.8,121.8,0,0,1-38.79-13.79q-2-1.11-3.89-2.28c-4.3-2.63-8.45-5.27-10.92-9.86a7.41,7.41,0,0,1-.87-5.46c.9-3.08,4.23-4.21,7.13-3.59,4.56,1,8.26,3.61,12.25,5.84A108.83,108.83,0,0,0,64.43,133C65.85,133.57,67.28,134.09,68.71,134.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.43da180118de62041897065010642fe9.svg";
export { ForwardRef as ReactComponent };